// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__5Dbuf","savePackageButton":"ClientWallet_savePackageButton__3pVg5"};